import { Link } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';

import ArrowCircleRight from '../../../../assets/svg/arrow-circle-right.svg';

const CardEnd = ({ data: { title, url } }) => (
  <div className="end">
    <div className="link">
      <Link aria-label={title} to={`${url}/`}>
        {title}
        <ArrowCircleRight aria-hidden="true" />
      </Link>
    </div>
  </div>
);

CardEnd.propTypes = {
  data: PropTypes.object,
};

export default CardEnd;
